import { useFetchData } from "hooks/useAxios";

export const useGetMain = () =>
  useFetchData<{
    monthOngoing: number;
    monthCompleted: number;
    monthReport: number;
    dayOngoing: number;
    dayCompleted: number;
    dayReport: number;
    startOfMonth: Date;
    startOfDay: Date;
    totalQuestions: number;
    totalQuestionsOnGoing: number;
    totalTransfers: number;
    totalTransfersNotAnswered: number;
    easyCount: number;
    mediumCount: number;
    hardCount: number;
    cantAnswerCount: number;
    classificationTypeCounts: Array<{
      classificationType: string;
      count: number;
    }>;
  }>({
    endpoint: "v1/common/main",
    queryKey: ["main"],
    showLoading: true,
  });
